module.exports = __webpack_public_path__ + "assets/ico-gps.ddf27b13.svg";